import { cn } from '@/lib/utils';
import { GNC_STICKER_VIEWBOX, gncStickerMarkup, type GncStickerName } from '@/lib/gnc-stickers';

/**
 * One GNC sticker (src/lib/gnc-stickers.ts). Decoration by default: it is
 * hidden from screen readers, so the text or aria-label next to it carries
 * the meaning. Size it with Tailwind (`h-6 w-6`). Pass `label` only when the
 * sticker is the only thing that says what a control does.
 */
export function GncSticker({
  name,
  className,
  label,
}: {
  name: GncStickerName;
  className?: string;
  label?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={GNC_STICKER_VIEWBOX}
      className={cn('gnc-sticker inline-block shrink-0', className)}
      data-gnc-sticker={name}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      // Fixed, trusted markup from our own sticker table, never user input.
      dangerouslySetInnerHTML={{ __html: gncStickerMarkup(name) }}
    />
  );
}
